import React, { useEffect } from "react";
import Filter from "../../Components/Filter";
import ParkList from "./ParkList/ParkList";
import axios from "axios";
import { Loading } from "../../Components/LoadingComponent";
import { filterActions } from "../../store/filter";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useQueries } from "react-query";
import { URL } from "../../Utils/url.api";
import { uiActions } from "../../store/ui";

function ParkCatalog() {
  const dispatch = useDispatch();
  const filters = useSelector((state) => state.filter.filters);
  const parks = useSelector((state) => state.filter.parksFilter);
  const imageFilter = useSelector((state) => state.filter.images);

  const getFilters = async () => {
    return await axios.get(URL + "ogtic/regions").then((data) => {
      dispatch(
        filterActions.defaultValues({
          values: data.data.data,
          method: "filter",
        })
      );
    });
  };

// useEffect(() =>{
//   getParks()
// },[])

  const getParks = async () => {
    return await axios.get(URL + "Parque/ObtenerTodosLosParquesSinImagenes").then((data) => {
      
      dispatch(
        filterActions.defaultValues({
          values: data.data.data,
          method: "park",
        })
      );
    });
  };

  const getImages = async () => {
    
    return await axios.get(URL + "Parque/ObtenerImagenesParques").then((data) => {
      
      dispatch(
        filterActions.defaultValues({
          values: data.data.data,
          method: "image",
        })
      );
    });

  };
  const queryResultss = useQueries([
  
    {
      queryKey: "image",
      queryFn: getImages,
    },
  ]);

  const queryResults = useQueries([
    {
      queryKey: "filter",
      queryFn: getFilters,
    },
    {
      queryKey: "park",
      queryFn: getParks,
    },
   
  ]);

  if (queryResults.some((result) => result.isLoading)) {
    dispatch(uiActions.ladingStatus({ conditional: true }));
    return "";
  }

  if (queryResults.every((result) => result.status === "success")) {
    dispatch(uiActions.ladingStatus({ conditional: false }));
  }

  return (
    <div className="flex flex-col tab-port:flex-row min-h-[inherit] max-w-[90vw] mx-auto">
      <div className="min-w-[28rem] tab-port:border-r-2">
        <Filter filterTitle="test" filterList={filters} />
      </div>
      <ParkList mainTitle="Áreas Protegidas" parkList={parks} imageFilter={imageFilter} />
    </div>
  );
}

export default ParkCatalog;
